<template>
  <div class="knowledgeBase">
    <div class="knowledgeBase-title">
      <span>欢迎回来，{{ username }}!</span>
    </div>
    <div class="knowledgeBase-content">
      <p>今天我们用哪个知识库？</p>
    </div>
    <div class="createKnowledgeBase">
      <button @click="showInputCard = true">创建知识库</button>
    </div>
    <div v-if="this.$store.state.username == 'admin'"
    class="switch-public" style="display:flex;flex-direction: row-reverse; margin-right: 40px; margin-top: 0px;">
      <el-switch v-model="ifprivate" active-color="#13ce66" inactive-color="#ff4949" active-text="个人知识库"
        inactive-text="公共知识库">
      </el-switch>
    </div>
    <div class="returnChat">
      <button @click="returnChat">返回聊天</button>
    </div>
    <div class="knowledgeBase-list">
      <KbfolderCard :currentUserId="currentUserId" @updateFolder="updateSubFolders"
        v-for="(folder, index) in subFoldersInfo" :key="index" :folderName="folder.folderName"
        :fileCount="folder.fileCount" :createdTime="folder.creationTime" :imgBase64="folder.imgBase64"
        :description="folder.description" style="margin-left: 20px;" />
    </div>

    <div v-if="showInputCard" class="inputCard">
      <InputCard inputMessage="请输入知识库名称" @confirm="verifyCreateKnowledgeBase" />
    </div>
  </div>
</template>

<script>
import InputCard from '../pannels/InputCard.vue';
import { createkbFolder, deletekbFolder, getkbFolderList, writekbConfig } from '../../api/auth';
import KbfolderCard from '../components/kb-folder-card.vue';
import { getkbConfig } from '../../api/auth';

export default {
  name: 'KnowledgeBase',
  components: {
    InputCard,
    KbfolderCard
  },
  data() {
    return {
      showInputCard: false,
      subFolders: [],
      subFoldersInfo: [],
      currentUserId: this.$store.state.userId,
      ifprivate: true
    };
  },
  methods: {
    //确认创建知识库
    verifyCreateKnowledgeBase(ifCreate, knowledgeBaseTitle) {
      if (ifCreate) {
        createkbFolder(this.currentUserId, knowledgeBaseTitle).then((res) => {
          console.log('创建知识库文件夹:', res);
          writekbConfig(
            this.currentUserId, 
            knowledgeBaseTitle, 
            '', 
            '请输入描述', 
            300, 
            '\n\n,\n', 
            100,
            'h0',
            false,
            false).then(() => {
            console.log('创建知识库文件夹配置文件');
          })
          getkbFolderList(this.currentUserId).then((res) => {
            console.log('获取知识库文件夹', res);
            this.subFolders = res.data;
            this.subFoldersInfo = [];
            for (let i = 0; i < this.subFolders.length; i++) {
              this.getFolderConfig(this.subFolders[i].name, this.subFolders[i].creationTime, this.subFolders[i].fileCount);
            }
          });
        });
      }
      this.showInputCard = false;
    },
    //删除知识库文件夹
    verifyDeleteKnowledgeBaseFolder(ifDelete, folderId) {
      if (!ifDelete) return;
      deletekbFolder(this.currentUserId, folderId).then((res) => {
        console.log('删除知识库文件夹:', res);
        getkbFolderList(this.currentUserId).then((res) => {
          console.log('获取知识库文件夹', res);
          this.subFolders = res.data;
          this.subFoldersInfo = [];
          for (let i = 0; i < this.subFolders.length; i++) {
            this.getFolderConfig(this.subFolders[i].name, this.subFolders[i].creationTime, this.subFolders[i].fileCount);
          }
        });
      });
    },
    //更新知识库文件夹
    updateSubFolders(res) {
      this.subFolders = res.data;
      this.subFoldersInfo = [];
      for (let i = 0; i < this.subFolders.length; i++) {
        this.getFolderConfig(this.subFolders[i].name, this.subFolders[i].creationTime, this.subFolders[i].fileCount);
      }

    },
    //返回聊天
    returnChat() {
      this.$router.push({ path: '/chat' });
    },
    //获取文件夹配置
    getFolderConfig(folderName, creationTime, fileCount) {
      getkbConfig(this.currentUserId, folderName).then((res) => {
        console.log('获取知识库配置文件', res);
        this.subFoldersInfo.push({ 'folderName': folderName, 'imgBase64': res.data.config.imgBase64, 'description': res.data.config.detail, 'fileCount': fileCount, 'creationTime': creationTime });
      });
    }

  },
  mounted() {
    getkbFolderList(this.currentUserId).then((res) => {
      console.log('获取知识库文件夹', res);
      this.subFolders = res.data;
      for (let i = 0; i < this.subFolders.length; i++) {
        this.getFolderConfig(this.subFolders[i].name, this.subFolders[i].creationTime, this.subFolders[i].fileCount);
      }
    });
  },
  // Add your logic here
  computed: {
    username() {
      return this.$store.state.username;
    },
  },
  watch: {
    ifprivate(newVal) {
      if (newVal) {
        this.currentUserId = this.$store.state.userId;
      } else {
        this.currentUserId = 'public';
        console.log('当前用户ID:', this.currentUserId);
      }
      getkbFolderList(this.currentUserId).then((res) => {
          console.log('获取知识库文件夹', res);
          this.subFolders = res.data;
          this.subFoldersInfo = [];
          for (let i = 0; i < this.subFolders.length; i++) {
            this.getFolderConfig(this.subFolders[i].name, this.subFolders[i].creationTime, this.subFolders[i].fileCount);
          }
        });
    },
  },
}
</script>

<style scoped>
/* Add your styles here */
.knowledgeBase {
  background-color: #F4F7FF;
  position: fixed;
  flex-direction: column;
  display: flex;
  top: 80px;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.knowledgeBase-title {
  display: flex;
  margin-top: 10px;
  margin-left: 40px;
  font-family: pingfangSC;
  font-size: 28px;
  font-weight: 600;
}

.knowledgeBase-content {
  margin-top: 10px;
  font-family: pingfangSC;
  font-size: 20px;
  margin-left: 40px;
}

.createKnowledgeBase button {
  margin-top: 30px;
  margin-left: 90px;
  width: 100px;
  height: 30px;
  border-radius: 5px;
  border: 0px;
  background: #187EFF;
  color: white;
  cursor: pointer;
}

.knowledgeBase-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  margin-left: 90px;
  gap: 15px;
}

.returnChat {
  position: fixed;
  top: 100px;
  right: 50px;
}

.returnChat button {
  width: 100px;
  height: 30px;
  border-radius: 5px;
  border: 0px;
  background: #187EFF;
  color: white;
  cursor: pointer;
}

/* 移动端响应式样式 */
@media screen and (max-width: 768px) {
  .knowledgeBase {
    top: 60px;
    padding: 10px;
  }

  .knowledgeBase-title {
    margin-left: 15px;
    font-size: 22px;
  }

  .knowledgeBase-content {
    margin-left: 15px;
    font-size: 16px;
  }

  .createKnowledgeBase button {
    margin-left: 15px;
    margin-top: 20px;
  }

  .knowledgeBase-list {
    margin-left: 0;
    padding: 0 15px;
    justify-content: center;
  }

  .returnChat {
    top: 70px;
    right: 15px;
  }

  .returnChat button {
    width: 80px;
    font-size: 14px;
  }

  .switch-public {
    margin-right: 15px !important;
    margin-top: 10px !important;
  }
}

@media screen and (max-width: 480px) {
  .knowledgeBase-list {
    flex-direction: column;
    align-items: center;
  }
}
</style>
